import {makeAutoObservable} from "mobx";
import {socket,} from "@services/socket";
import {sessionStore} from "@services/session";
import {socketStore} from "@services/socket";

export class AppStore {

    isAppInitialized = false

    constructor() {
        makeAutoObservable(this);
    }

    setAppInitialized = (isAppInitialized: boolean) => {
        this.isAppInitialized = isAppInitialized
    }

    initializeApp = async () => {
         await Promise.all([sessionStore.getAuthMe()])
            .then( data => {
                const [authData] = data;

                this.setAppInitialized(true)

                socket.connect()
                socketStore.connectionHandler()
                if (authData) {
                    console.log(authData)
                    // socket.emit('joinRoom', `${data[0].id}`)
                }
            })
    }

    cancelAppInitialization = () => {
        this.setAppInitialized(false)

        socketStore.closeConnectionHandler()
        socket.disconnect()
    }

}

export const appStore = new AppStore()
